import TEXT from './generated/TEXT/QuickSearch_GetScreenReaderText';
import { isFolder } from './isFolder';
import { isProject } from './isProject';

TEXT.DEFINE({
  /** Screen reader prefix for project type */
  projectPrefix: 'Project: ',
  /** Screen reader prefix for folder type */
  folderPrefix: 'Folder: ',
  /** Word "Asset" as used in asset type labels (e.g. "Video Asset") */
  asset: 'Asset',
});

type Props = {
  name: string;
  type: string;
};

export const getScreenReaderText = ({ name, type }: Props) => {
  const prefix = getCellTypePrefixCopy(type);

  return `${prefix} ${name}`;
};

function getCellTypePrefixCopy(type: string) {
  if (isProject(type)) {
    return TEXT.projectPrefix;
  }
  if (isFolder(type)) {
    return TEXT.folderPrefix;
  }
  return `${type.replace('Asset', ` ${TEXT.asset}`)}:`;
}

export const testExports = { getCellTypePrefixCopy, TEXT };
